import ATPartnerSvg from 'src/assets/images/at-partner.svg';
import styled from 'styled-components';

export const ATPartner = styled(ATPartnerSvg)`
  height: 0.875rem;
  width: 2.5rem;
`;
